import { useState, useEffect } from "react";
import * as S from './styles';

function MeuInput({ label, updateValue, isPhoneNumber, value }) {
  const [inputValue, setInputValue] = useState("");

  const handleSearchChange = (event) => {
    let value = event.target.value;
    if (isPhoneNumber) {
      value = formatPhoneNumber(value);
    }
    setInputValue(value);
    updateValue(value);
  };

const formatPhoneNumber = (value) => {
    // 1. Remove all non-digit characters from the input value
    const numericValue = value.replace(/[^\d]/g, '');

    // 2. Apply the desired formatting
    let formattedNumber = '';
    if (numericValue.length > 0) {
      formattedNumber += '(' + numericValue.slice(0, 2);
    }
    if (numericValue.length > 2) {
      formattedNumber += ') ' + numericValue.slice(2, 7);
    }
    if (numericValue.length > 7) {
      formattedNumber += '-' + numericValue.slice(7, 12);
    }

    return formattedNumber;
  };

  useEffect(() => {
    if (value) {
      setInputValue(value);
    }
  }, [value]);

  return (
    <S.InputGroup>
      {inputValue.length > 0 && (<span>{label}</span>)}
      <S.InputWrapper>
      <input
        type={isPhoneNumber ? "tel" : "text"}
        value={inputValue}
        placeholder={label}
        maxLength={isPhoneNumber ? 15 : 255}
        onChange={handleSearchChange}
      /></S.InputWrapper>
    </S.InputGroup>
  );
}
export default MeuInput;
